import { Outlet } from 'react-router-dom'
import { AuthenticatedLayout } from '@/app/layouts/AuthenticatedLayout'
import { RequireAuth } from '@/features/auth'
import { AvisoDeNovedades } from '@/features/novedades'

/**
 * Shell del área autenticada.
 * El `<Outlet />` proyecta la página activa dentro del layout (sidebar + topbar).
 * `RequireAuth` corre arriba: si no hay sesión, redirige a `/login` ANTES de
 * montar el shell.
 *
 * Vive en su propio fichero porque `routeConfig.tsx` exporta la tabla de rutas
 * (un valor, no un componente) y `react-refresh/only-export-components` no
 * admite ambas cosas en el mismo módulo.
 *
 * `AvisoDeNovedades` cuelga aquí (goal novedades-del-portal 2) y no de una
 * página: así hay sesión garantizada antes de preguntar nada —`RequireAuth`
 * corre arriba— y el aviso se SUPERPONE a lo que el usuario venía a hacer, en
 * vez de meterse entre él y su lista de negocios. Sin novedades pendientes no
 * renderiza ni un nodo.
 */
export function AppShell() {
  return (
    <RequireAuth>
      <AuthenticatedLayout>
        <Outlet />
      </AuthenticatedLayout>
      <AvisoDeNovedades />
    </RequireAuth>
  )
}
